export const themeColors = {
    cyan: {
        50: '#e8f9fd', 100: '#c7f0fb', 200: '#93e2f7', 300: '#57cdf0', 400: '#2bc2eb',
        500: '#19b8e8', 600: '#0789d5', 700: '#066fae', 800: '#0a5585', 900: '#0d476c',
        label: 'Cyan',
        className: 'cyan'
    }
};

export const applyTheme = (themeColor = 'cyan', persist = true) => {
    const colors = themeColors.cyan;
    if (colors) {
        const root = document.documentElement;
        Object.keys(colors).forEach(key => {
            if (key !== 'label' && key !== 'className') {
                root.style.setProperty(`--primary-${key}`, colors[key]);
            }
        });
        if (persist) {
            localStorage.setItem('themeColor', 'cyan');
        }
        window.dispatchEvent(new Event('themeChanged'));
    }
};

export const initTheme = () => {
    applyTheme('cyan', true);
};

export const getPrimaryColor = () => {
    return getComputedStyle(document.documentElement).getPropertyValue('--primary-600').trim() || '#0789d5';
};
